const PASSKEY_FLAG_KEY = 'football_subs_passkey_enrolled';
const PASSKEY_EMAIL_KEY = 'football_subs_passkey_email';
const PASSKEY_PROMPT_DISMISSED_KEY = 'football_subs_passkey_prompt_dismissed';

/** Device-local flag: this browser/PWA has registered a passkey. */
export function hasLocalPasskey() {
  try {
    return localStorage.getItem(PASSKEY_FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Which account's passkey this device holds, if known. Older enrolments
 * (recorded before this field existed) return null — the passkey button
 * still works, it just can't be labelled with an email.
 */
export function getLocalPasskeyEmail() {
  try {
    return localStorage.getItem(PASSKEY_EMAIL_KEY) || null;
  } catch {
    return null;
  }
}

export function setLocalPasskeyEnrolled(enrolled = true, email = null) {
  try {
    if (enrolled) {
      localStorage.setItem(PASSKEY_FLAG_KEY, '1');
      localStorage.setItem(PASSKEY_PROMPT_DISMISSED_KEY, '1');
      if (email) localStorage.setItem(PASSKEY_EMAIL_KEY, String(email).toLowerCase());
    } else {
      localStorage.removeItem(PASSKEY_FLAG_KEY);
      localStorage.removeItem(PASSKEY_EMAIL_KEY);
    }
  } catch {
    // ignore quota / private mode
  }
}

export function isPasskeyPromptDismissed() {
  try {
    return localStorage.getItem(PASSKEY_PROMPT_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissPasskeyPrompt() {
  try {
    localStorage.setItem(PASSKEY_PROMPT_DISMISSED_KEY, '1');
  } catch {
    // ignore
  }
}
